import React from "react";
import { useParams } from "react-router-dom";
import "./ServiceDetail.css"; // Import the CSS for styling
import accounting from "../assets/accounting-big.png";
import accounting1 from "../assets/serviceDetails/Accounting/accounting.png"
import accounting2 from "../assets/serviceDetails/Accounting/ledger.png"
import accounting3 from "../assets/serviceDetails/Accounting/account-payable-recievable.png"
import accounting4 from "../assets/serviceDetails/Accounting/budget-forecast.png"
import accounting5 from "../assets/serviceDetails/Accounting/bank-recconciliation.png"
import accounting6 from "../assets/serviceDetails/Accounting/compliance-audit.png"
import accounting7 from "../assets/serviceDetails/Accounting/financial-statement.png"
import accounting8 from "../assets/serviceDetails/Accounting/financial-audit.png"

import tax from "../assets/tax.png"
import tax1 from "../assets/serviceDetails/Tax/comprehensive-tax.png"
import tax2 from "../assets/serviceDetails/Tax/international-tax.png"
import tax3 from "../assets/serviceDetails/Tax/corporate-tax.png"
import tax4 from "../assets/serviceDetails/Tax/tax-optimize.png"
import tax5 from "../assets/serviceDetails/Tax/gst-compliance.png"
import tax6 from "../assets/serviceDetails/Tax/tax-filling.png"
import tax7 from "../assets/serviceDetails/Tax/income-tax.png"
import tax8 from "../assets/serviceDetails/Tax/tax-representation.png"

import wealth from "../assets/wealth.png"
import wealth1 from "../assets/serviceDetails/wealth/wealth-management.png"
import wealth2 from "../assets/serviceDetails/wealth/estate-planning.png"
import wealth3 from "../assets/serviceDetails/wealth/investment-advisory.png"
import wealth4 from "../assets/serviceDetails/wealth/portfolio-management.png"
import wealth5 from "../assets/serviceDetails/wealth/asset-allocation.png"
import wealth6 from "../assets/serviceDetails/wealth/risk-assesment.png"
import wealth7 from "../assets/serviceDetails/wealth/retirement-planning.png"
import wealth8 from "../assets/serviceDetails/wealth/alternative-investment.png"

import loan from "../assets/credit-card.png"
import loan1 from "../assets/serviceDetails/loan//home-loan.png"
import loan2 from "../assets/serviceDetails/loan/education-loan.png"
import loan3 from "../assets/serviceDetails/loan/personal-loan.png"
import loan4 from "../assets/serviceDetails/loan/business-loan.png"
import loan5 from "../assets/serviceDetails/loan/car-loan.png"
import loan6 from "../assets/serviceDetails/loan/credit-cards.png"

import business from "../assets/business-advisory.png"
import business1 from "../assets/serviceDetails/busisness/business-formation.png"
import business2 from "../assets/serviceDetails/busisness/business-formation.png"
import business3 from "../assets/serviceDetails/busisness/business-financial-planning.png"
import business4 from "../assets/serviceDetails/busisness/market-research.png"
import business5 from "../assets/serviceDetails/busisness/mergers.png"
import business6 from "../assets/serviceDetails/busisness/business-process.png"
import business7 from "../assets/serviceDetails/busisness/corporate-governance.png"
import business8 from "../assets/serviceDetails/busisness/risk-assesment.png"

import data from "../assets/data-analytics.png"
import data1 from "../assets/serviceDetails/data/data-analysis.png"
import data2 from "../assets/serviceDetails/data/dashboard-development.png"
import data3 from "../assets/serviceDetails/data/financial-modeling.png"
import data4 from "../assets/serviceDetails/data/data-mining.png"
import data5 from "../assets/serviceDetails/data/analytic-solution.png"
import data6 from "../assets/serviceDetails/data/reporting-automation.png"
import data7 from "../assets/serviceDetails/data/business-reporting.png"
import data8 from "../assets/serviceDetails/data/big-data-analysis.png"


const serviceDetails = {
  "accounting-financial-reporting": {
    title: "Accounting and Financial Reporting",
    description: `At Tax o Wealth, our expert team is dedicated to ensuring that your business maintains accurate and comprehensive financial records. We understand the importance of reliable data in making informed decisions and maintaining compliance with regulatory standards. Our services are designed to support your business at every financial cycle stage, providing clear, consistent, and audit-ready reports that reflect your true financial status.
    
    Our professionals are skilled in a range of financial disciplines and utilize the latest accounting software and methodologies. This blend of expertise and technology ensures that our financial reporting is not only compliant with current accounting standards but also strategically insightful, helping you understand the underlying trends and opportunities within your financial data.`,
    image: accounting,
    points: [
      {
        icon: accounting1,
        title: "Accounting and Bookkeeping Services",
        text: "Tax O Wealth provides comprehensive accounting and bookkeeping services, ensuring compliance and effective financial management. Our tailored solutions offer continuous financial analysis and insights, optimizing performance and reducing your administrative burden.",
      },
      {
        icon: accounting2,
        title: "General Ledger Maintenance",
        text: "Tax O Wealth maintains precise general ledgers, ensuring financial integrity and compliance. Efficient audit preparation and reliable reporting are supported, guaranteeing consistency across all operations.",
      },
      {
        icon: accounting3,
        title: "Accounts Payable and Receivables",
        text: "Tax O Wealth streamlines your accounts payable and receivables to enhance liquidity and manage cash flow effectively. Our proactive services improve relationships and provide insights into cash flow cycles for optimal financial stability.",
      },
      {
        icon: accounting4,
        title: "Budgeting and Forecasting",
        text: "Tax O Wealth's budgeting and forecasting services empower you to plan confidently for the future. We tailor solutions to your business's needs, enabling informed decisions and effective resource allocation. Our strategic planning ensures financial health and resilience in volatile markets.",
      },

      {
        icon: accounting5,
        title: "Bank Reconciliation",
        text: "Tax O Wealth's bank reconciliation services verify the accuracy of your financial records, ensuring each transaction aligns with your bank statements and highlighting discrepancies to prevent fraud. Our commitment to meticulous detail provides confidence in your financial integrity and accountability.",
      },
      {
        icon: accounting6,
        title: "Compliance Audits and Due Diligence",
        text: "Tax O Wealth conducts compliance audits and due diligence to ensure legal adherence and mitigate risks. We provide detailed reports for maintaining or improving compliance standards and offer comprehensive evaluations for informed decision-making in mergers and acquisitions.",
      },
      {
        icon: accounting7,
        title: "Financial Statement Preparation and Analysis",
        text: "Tax O Wealth excels in preparing and analyzing financial statements to reflect your business's performance accurately and ensure compliance. Our expert analysis offers deep insights for strategic decision-making, identifying trends, and assessing risks, empowering stakeholders to make informed choices.",
      },
      {
        icon: accounting8,
        title: "Financial Auditing and Internal Audits",
        text: "Tax O Wealth's financial auditing and internal audits bolster the transparency and credibility of your financial statements. Our rigorous processes identify discrepancies, ensuring compliance and offering valuable insights for efficiency and integrity. We go beyond compliance to optimize internal controls, mitigating risks and enhancing operational performance for sustained success.",
      },
    ],
  },
  "tax-planning-compliance": {
    title: "Tax Planning and Compliance",
    description: `At Tax O Wealth , we recognize the complexities of tax management and strive to provide our clients with optimized tax solutions that enhance their financial efficiency and compliance. Our team of tax experts specializes in navigating the intricate world of taxes, ensuring that your obligations are met and your opportunities maximized. We offer a full suite of tax services, from planning and compliance to representation and dispute resolution, tailored to the unique needs of both individuals and businesses.
    
    Our approach involves proactive strategies that anticipate tax implications and align them with your business objectives. We stay abreast of the latest tax regulations and changes to provide timely and authoritative advice. By integrating our tax planning with your overall financial goals, we help minimize liabilities and maximize compliance, thereby reducing your tax burden while supporting your financial success.`,
    image: tax,
    points: [
      {
        icon: tax1,
        title: "Comprehensive Tax Planning",
        text: "Tax O Wealth offers comprehensive tax planning, aligning strategies with your goals for maximum savings. Our proactive approach anticipates liabilities, adapting to changes in your financial landscape and tax laws. With our robust service, maintain efficiency and achieve financial goals with minimized tax liabilities.",
      },
      {
        icon: tax2,
        title: "International Tax Planning",
        text: "Tax O Wealth offers international tax planning, minimizing liabilities and ensuring compliance across borders. Essential for global expansion, our services align operations with efficient tax strategies, providing clarity and confidence in international growth.",
      },
      {
        icon: tax3,
        title: "Corporate Tax Planning",
        text: "Tax O Wealth's corporate tax planning offers strategic analysis to optimize efficiencies and identify savings. Tailored to your business, our experts ensure compliance and maximize incentives, enhancing profitability and shareholder value in a complex regulatory landscape.",
      },
      {
        icon: tax4,
        title: "Tax Optimization Strategies",
        text: "Tax O Wealth's tax optimization strategies aim to achieve the most favorable tax position for you. Through thorough analysis, we identify opportunities for lawful tax minimization. Our dynamic solutions ensure compliance while maximizing tax efficiencies, supporting sustainable growth and financial health.",
      },
      {
        icon: tax5,
        title: "GST Compliance and Advisory",
        text: "Tax O Wealth offers expert GST compliance and advisory services, ensuring regulatory adherence and optimizing cash flows. From registration to timely returns, we guide you through complex transactions, leveraging GST regulations for operational efficiency and cost-effectiveness.",
      },
      {
        icon: tax6,
        title: "Tax Filing Assistance",
        text: "Tax O Wealth provides comprehensive tax filing assistance for individuals and businesses, ensuring accurate and timely submissions without the stress of tax season. With our expert team, you can trust that your tax affairs are in capable hands.",
      },
      {
        icon: tax7,
        title: "Income Tax Planning and Preparation",
        text: "Tax O Wealth's income tax planning and preparation services aim to minimize liabilities and ensure accurate filings. We tailor strategies to maximize deductions and credits, ensuring compliance and optimizing returns to mitigate conflicts and penalties.",
      },
      {
        icon: tax8,
        title: "Tax Representation and Dispute Resolution",
        text: "Tax O Wealth offers expert tax representation and dispute resolution, advocating for you with tax authorities to achieve favorable outcomes. From initial inquiries to tribunal appearances, we protect your interests and ensure effective tax management for your financial future.",
      },
    ],
  },
  "wealth-investment-management": {
    title: "Wealth and Investment Management",
    description: `At Tax O Wealth, we understand that effective wealth and investment management is critical to achieving and maintaining long-term financial security. Our tailored services are designed to address the unique needs of each client, whether they are individuals, families, or businesses. By combining personalized advice, robust financial strategies, and continuous portfolio oversight, we help our clients navigate the complexities of wealth management and achieve their financial goals.
    
    Our team of experienced advisors is committed to building and maintaining trust through transparent and informed guidance. We employ a holistic approach that encompasses all aspects of wealth management, from investment selection to estate planning, ensuring that every facet of your financial future is secure. With Tax o Wealth, you gain a partner who is dedicated to your long-term success and peace of mind.`,
    image: wealth,
    points: [
      {
        icon: wealth1,
        title: "Wealth Management Services",
        text: "Tax O Wealth offers comprehensive wealth management services tailored to your goals, ensuring financial security and independence. With customized strategies and ongoing review, we maximize wealth accumulation and preservation, guiding you towards financial success.",
      },
      {
        icon: wealth2,
        title: "Estate Planning and Trust Services",
        text: "Tax O Wealth's estate planning and trust services safeguard your assets and ensure they're distributed according to your wishes. From wills to trusts and estate taxes, we provide expert guidance for a secure financial legacy. Working with legal experts, we ensure your plan reflects your preferences, offering peace of mind and a smooth transition for your loved ones.",
      },
      {
        icon: wealth3,
        title: "Investment Advisory Services",
        text: "Tax o Wealth's investment advisory services offer expert guidance on asset selection and portfolio construction, tailored to your goals and risk tolerance. We utilize market analysis to identify opportunities, ensuring your investments align with your objectives for long-term growth and stability.",
      },
      {
        icon: wealth4,
        title: "Portfolio Management and Review",
        text: "Tax O Wealth offers portfolio management and review services, actively managing your investments to optimize performance and mitigate risk. With continuous monitoring and adjustments, we keep your strategy aligned with your goals, providing confidence in a dynamic financial landscape.",
      },
      {
        icon: wealth5,
        title: "Asset Allocation and Management",
        text: "Tax O Wealth employs sophisticated models to design portfolios tailored to your goals, optimizing risk and return. Our strategic asset allocation ensures diversification, reducing risk and maximizing returns. With continual monitoring and adjustments, we keep your investments aligned with your long-term objectives, prioritizing transparency and growth.",
      },
      {
        icon: wealth6,
        title: "Risk Management and Diversification",
        text: "Tax O Wealth employs advanced risk assessment techniques to identify and mitigate investment threats, emphasizing diversification across asset classes and regions. Our strategy not only shields against market volatility but also positions portfolios for potential gains. With a focus on diversification, we navigate complex markets for stable financial growth.",
      },
      {
        icon: wealth7,
        title: "Retirement Planning and Analysis",
        text: "Tax o Wealth offers comprehensive retirement planning and analysis to ensure a comfortable future. We assess your financial situation, estimate retirement needs, and devise strategies for your desired lifestyle. With a focus on tax-efficient withdrawals and continuous performance analysis, we guide you towards a secure retirement, every step of the way.",
      },
      {
        icon: wealth8,
        title: "Alternative Investment Opportunities",
        text: "Tax o Wealth provides access to alternative investment opportunities like private equity, real estate, and hedge funds. These offer diversification, reduced volatility, and potential for higher returns. We assess suitability based on your strategy and risk tolerance, leveraging expertise to manage associated risks and enhance portfolio potential.",
      },
    ],
  },
  "loan-credit-card": {
    title: "Loan & Credit Card Services",
    description: `At Tax o Wealth, we take pride in offering a comprehensive suite of loan and credit card services to cater to the diverse financial needs of our valued clients. With our extensive network of partner banks and NBFCs, we bring you a wide range of borrowing options coupled with personalized assistance and expert guidance every step of the way.
    
    "At Tax O Wealth, we understand that financial needs vary from person to person and from one stage of life to another. That's why we're proud to offer a comprehensive suite of loan and credit card services designed to cater to the diverse needs of our clients. Whether you're looking to purchase a home, fund your child's education, expand your business, or simply need a convenient way to manage your day-to-day expenses, we have the expertise and resources to help you find the right borrowing solutions tailored to your unique circumstances.
    
    Our team of experienced financial advisors understands that navigating the world of lending can be overwhelming, which is why we're here to provide you with personalized assistance and expert guidance every step of the way. From helping you choose the right loan product to guiding you through the application process and beyond, we're committed to making your borrowing experience as seamless and stress-free as possible.
    
    With our extensive network of partner banks and NBFCs, we bring you a wide range of borrowing options, competitive interest rates, and flexible repayment terms to suit your needs. Whether you're looking for a home loan, personal loan, car loan, education loan, business loan, or credit card, you can count on Tax o Wealth to help you achieve your financial goals with confidence.
    
    Contact us today to learn more about our loan and credit card services and discover how we can help you achieve your financial aspirations."`,
    image: loan,
    points: [
      {
        icon: loan1,
        title: "Home Loans",
        text: "Tax O Wealth understands the significance of securing a home loan tailored to your needs. Whether you're a first-time buyer or refinancing, our specialists offer competitive rates, flexible terms, and personalized guidance for a stress-free experience.",
      },
      {
        icon: loan2,
        title: "Education Loans",
        text: "Tax O Wealth's education loan services help turn academic aspirations into reality, whether for higher education abroad or top-tier institutions. With competitive rates, flexible terms, and personalized assistance, we guide you through the funding process with ease. Achieve your educational goals without financial strain, with Tax o Wealth by your side.",
      },
      {
        icon: loan3,
        title: "Personal Loans",
        text: "Tax O Wealth's personal loan services offer financial flexibility for life's challenges and dreams. Whether for a wedding, medical expenses, or debt consolidation, our experts tailor borrowing solutions to your circumstances. With fast approvals, competitive rates, and flexible repayment, we're your trusted partner for personal lending.",
      },
      {
        icon: loan4,
        title: "Business Loans",
        text: "Tax O Wealth's business loan services provide entrepreneurs and business owners with the capital needed to fuel growth and innovation. Whether launching a new venture or expanding operations, our specialists tailor financing solutions to your unique needs. With flexible terms, competitive rates, and personalized guidance, Tax o Wealth is your trusted partner for business lending.",
      },
      {
        icon: loan5,
        title: "Car Loans",
        text: "Tax O Wealth's car loan services offer hassle-free financing for your dream vehicle, whether new or used. With competitive rates and flexible terms, our specialists ensure quick approvals and seamless processing, making us your go-to destination for auto financing.",
      },
      {
        icon: loan6,
        title: "Credit Cards",
        text: "Tax O Wealth's credit card services offer a variety of options to suit your lifestyle and spending habits. Whether you seek rewards, cashback, travel benefits, or low-interest rates, our experts will help you find the perfect card. With quick approvals, exclusive offers, and round-the-clock support, Tax o Wealth is your one-stop destination for credit cards.",
      },
    ],
  },
  "business-advisory-consulting": {
    title: "Business Advisory and Consulting",
    description: `At Tax O Wealth, we offer strategic business advisory and consulting services aimed at guiding our clients through every stage of their business journey. Whether you are a startup looking to establish your presence or an established corporation seeking to optimize your operations, our expert advisors are here to help. Our comprehensive suite of services encompasses everything from business formation and financial planning to mergers and acquisitions advisory and corporate governance.
    
    We understand that every business is unique, which is why we tailor our advisory services to meet the specific needs and goals of each client. Our team brings a wealth of industry experience and expertise to the table, providing insightful guidance and practical solutions that drive growth, enhance efficiency, and maximize profitability. With Tax o Wealth as your trusted advisor, you can navigate the complexities of the business landscape with confidence.`,
    image: business,
    points: [
      {
        icon: business1,
        title: "Business Formation and Registration Services",
        text: "Tax O Wealth offers comprehensive support for business formation, guiding entrepreneurs through selecting legal structures and completing paperwork efficiently, so they can focus on business growth.",
      },
      {
        icon: business2,
        title: "Strategic Planning and Consulting",
        text: "Tax O Wealth provides strategic planning services to align businesses with long-term goals, driving growth and profitability by identifying opportunities for differentiation and value creation.",
      },
      {
        icon: business3,
        title: "Business Financial Planning",
        text: "Tax O Wealth provides tailored financial plans for businesses, aligning short-term objectives with long-term goals. Our expert advisors help secure funding, expand operations, and improve cash flow management, ensuring financial resilience. Leveraging industry insights, we identify growth opportunities and mitigate risks for sustained success.",
      },
      {
        icon: business4,
        title: "Market Research and Analysis",
        text: "Tax O Wealth offers market research and analysis services, providing businesses with valuable insights for informed decision-making in a competitive market.",
      },
      {
        icon: business5,
        title: "Mergers and Acquisitions Advisory",
        text: "Tax o Wealth provides expert advisory services for mergers and acquisitions, guiding businesses through every stage of the process to achieve strategic objectives efficiently.",
      },
      {
        icon: business6,
        title: "Business Process Management",
        text: "Tax O Wealth's BPM services streamline operations, optimize productivity, and drive growth by analyzing processes, identifying inefficiencies, and implementing best practices.",
      },
      {
        icon: business7,
        title: "Corporate Governance Advisory",
        text: "Tax O Wealth provides corporate governance advisory services, collaborating with businesses to establish robust frameworks, ensuring integrity, compliance, and long-term value creation.",
      },
      {
        icon: business8,
        title: "Risk Assessment and Management",
        text: "Tax o Wealth provides risk assessment and management services to safeguard business value and ensure long-term sustainability. Our experienced consultants develop customized strategies tailored to your risk tolerance and objectives, helping you identify, assess, and mitigate financial, operational, and strategic risks.",
      },
    ],
  },
  "data-analytics-reporting": {
    title: "Data Analytics and Reporting",
    description: `At Tax O Wealth, we understand the importance of data-driven insights in making informed business decisions and driving organizational success. Our Data Analytics and Reporting services are designed to empower businesses with the tools and knowledge needed to unlock the full potential of their data. From data analysis and interpretation to predictive analytics solutions and big data implementation, we offer a comprehensive suite of services tailored to meet the unique needs of each client.
    
    Our team of experienced data analysts and reporting specialists leverages advanced analytics tools and methodologies to extract actionable insights from complex datasets. Whether you are looking to optimize financial performance, improve operational efficiency, or enhance customer satisfaction, our Data Analytics and Reporting services can help you achieve your business objectives with confidence.`,
    image: data,
    points: [
      {
        icon: data1,
        title: "Data Analysis and Interpretation",
        text: "Tax O Wealth offers comprehensive data analysis services, utilizing advanced techniques to extract valuable insights from your data. Whether it's sales trends or operational performance, our analysis helps drive informed decisions.",
      },
      {
        icon: data2,
        title: "Dashboard Developments",
        text: "We specialize in creating interactive and customizable dashboards tailored to your business needs, enabling real-time monitoring of key metrics and trends.",
      },
      {
        icon: data3,
        title: "Financial Modeling and Valuation",
        text: "Tax O Wealth provides expert financial modeling services to evaluate business performance and assess investment opportunities accurately. Our models offer insights into future performance and potential risks.",
      },
      {
        icon: data4,
        title: "Data Mining and Text Analytics",
        text: "With advanced data mining and text analytics, Tax o Wealth helps uncover actionable insights from unstructured data sources such as social media posts and customer reviews.",
      },
      {
        icon: data5,
        title: "Predictive Analytics Solutions",
        text: "Our predictive analytics solutions help anticipate future trends and outcomes based on historical data, empowering businesses to identify opportunities and mitigate risks effectively.",
      },
      {
        icon: data6,
        title: "Reporting Automation",
        text: "Our reporting automation services streamline the process of generating and distributing reports, improving efficiency and accuracy in decision-making.",
      },
      {
        icon: data7,
        title: "Business Intelligence Reporting",
        text: "Tax O Wealth delivers customized business intelligence reports and dashboards, transforming raw data into actionable insights. Our reporting services empower stakeholders to make informed decisions.",
      },
      {
        icon: data8,
        title: "Big Data Analytics and Implementation",
        text: "Tax O Wealth offers expert big data analytics services to extract valuable insights from large and complex datasets, driving innovation and competitive advantage for businesses.",
      },
    ],
  }
};

const ServiceDetail = () => {
  const { serviceId } = useParams();
  const service = serviceDetails[serviceId];

  if (!service) {
    return (
      <div className="service-detail">
        <h2>Service Not Found</h2>
        <p>The service you're looking for does not exist.</p>
      </div>
    );
  }

  return (
    <div className="service-detail">
      <div className="trail">
        <p>
          <a href="/">Home</a> / <a href="/services">Services</a> / {service.title}
        </p>
      </div>

      <div className="service-header">
        <img src={service.image} alt={service.title} className="main-image" />
        <div className="service-content">
          <h2>{service.title}</h2>
          {service.description.split("\n").map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
      </div>

      <div className="service-points">
        {service.points.map((point, index) => (
          <div className="service-point" key={index} style={{ animationDelay: `${index * 0.2}s` }}>
            <img src={point.icon} alt={point.title} className="point-icon" />
            <div className="point-content">
              <h3>{point.title}</h3>
              <p>{point.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceDetail;
